module.exports = __webpack_public_path__ + "img/dp-sy-lm2.03aed462.png";